import { render, staticRenderFns } from "./CargoLifeCycle.vue?vue&type=template&id=35407cc2&"
import script from "./CargoLifeCycle.vue?vue&type=script&lang=js&"
export * from "./CargoLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./CargoLifeCycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoLifeCycle.vue"
export default component.exports